/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The MetricParamsTime model module.
 * @module model/MetricParamsTime
 * @version 0.0.2
 */
export class MetricParamsTime {
  /**
   * Constructs a new <code>MetricParamsTime</code>.
   * @alias module:model/MetricParamsTime
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>MetricParamsTime</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MetricParamsTime} obj Optional instance to populate.
   * @return {module:model/MetricParamsTime} The populated <code>MetricParamsTime</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MetricParamsTime();
      if (data.hasOwnProperty('minutesSetup'))
        obj.minutesSetup = ApiClient.convertToType(data['minutesSetup'], 'Number');
      if (data.hasOwnProperty('minutesTeardown'))
        obj.minutesTeardown = ApiClient.convertToType(data['minutesTeardown'], 'Number');
      if (data.hasOwnProperty('minutesCongestion'))
        obj.minutesCongestion = ApiClient.convertToType(data['minutesCongestion'], 'Number');
      if (data.hasOwnProperty('minutesParking'))
        obj.minutesParking = ApiClient.convertToType(data['minutesParking'], 'Number');
      if (data.hasOwnProperty('trafficFactor'))
        obj.trafficFactor = ApiClient.convertToType(data['trafficFactor'], 'Number');
      if (data.hasOwnProperty('speedFactor'))
        obj.speedFactor = ApiClient.convertToType(data['speedFactor'], 'Number');
      if (data.hasOwnProperty('speedInKmh'))
        obj.speedInKmh = ApiClient.convertToType(data['speedInKmh'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} minutesSetup
 */
MetricParamsTime.prototype.minutesSetup = undefined;

/**
 * @member {Number} minutesTeardown
 */
MetricParamsTime.prototype.minutesTeardown = undefined;

/**
 * @member {Number} minutesCongestion
 */
MetricParamsTime.prototype.minutesCongestion = undefined;

/**
 * @member {Number} minutesParking
 */
MetricParamsTime.prototype.minutesParking = undefined;

/**
 * only applies if routingOpts.mode == CAR
 * @member {Number} trafficFactor
 */
MetricParamsTime.prototype.trafficFactor = undefined;

/**
 * @member {Number} speedFactor
 */
MetricParamsTime.prototype.speedFactor = undefined;

/**
 * @member {Number} speedInKmh
 */
MetricParamsTime.prototype.speedInKmh = undefined;

